(function () {
    'use strict';

    angular.module("imApp").factory("travelExpenceService", ['$ihttp', function ($ihttp) {
        let service = {
            getTravelExpence: function (parms) {
                return $ihttp.post({
                    method: 1266,
                    parameters: parms || {}
                });
            },
            listExpenceTypes: function (parms) {
                return $ihttp.post({
                    method: 1265,
                    parameters: parms || {}
                });
            },
            getCurrencyExRate: function (parms) {
                return $ihttp.post({
                    method: 1277,
                    parameters: parms || {}
                });
            },
            getExchangeFactor: function (parms) {
                return $ihttp.post({
                    method: 1278,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1274,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 1275,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
